import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import LockIcon from '@mui/icons-material/Lock';
import { useTranslation } from 'react-i18next';
import type { DialogTitleContentProps } from '../types';

export function DialogTitleContent({ step, title }: DialogTitleContentProps) {
  const { t } = useTranslation('signature');

  if (step === 'success') {
    return (
      <>
        <CheckCircleIcon color="success" />
        {t('titleSuccess')}
      </>
    );
  }

  if (step === 'error') {
    return (
      <>
        <ErrorIcon color="error" />
        {t('titleError')}
      </>
    );
  }

  return (
    <>
      <LockIcon color="primary" />
      {title}
    </>
  );
}
